import { ReactElement, useCallback } from 'react'
import WeekdayTemplate from './template'
import { useSteps } from '../../../../contexts/stepContext'
import {
    CompanyActions,
    CompanyLeadState,
} from '@raskrask-dk/bookingflow-state-machine'
import { useBFSMValue } from '../../../../services/hooks/useBFSMValues'
import { ShortWeekDayString } from '@raskrask-dk/raskrask-utils'

const WeekdayPage = (): ReactElement => {
    const [currentStep, helpers] = useSteps()

    const [companySettings, setCompanySettings] = useBFSMValue<
        CompanyLeadState,
        CompanyActions.SetCompanySettings,
        'companySettings'
    >('companySettings', CompanyActions.SetCompanySettings)

    const updatedWantedWeekDays = (
        newDay: ShortWeekDayString,
        weekDays?: ShortWeekDayString[]
    ) => {
        if (weekDays) {
            const isInArray =
                weekDays.filter((e: string) => e === newDay).length > 0

            if (isInArray) {
                return weekDays.filter((day: string) => day !== newDay)
            } else {
                return [...weekDays, newDay]
            }
        } else {
            return [newDay]
        }
    }

    const onClickWeekDay = useCallback(
        (day: ShortWeekDayString) => {
            setCompanySettings({
                ...companySettings,
                wantedWeekDays: updatedWantedWeekDays(
                    day,
                    companySettings?.wantedWeekDays
                ),
            })
        },
        [companySettings, setCompanySettings]
    )

    return (
        <WeekdayTemplate
            weekDays={companySettings?.wantedWeekDays}
            currentStep={currentStep}
            helpers={helpers}
            onClickWeekDay={onClickWeekDay}
            dataCy={'accordion-weekday'}
        />
    )
}

export default WeekdayPage
